module.exports = __webpack_public_path__ + "c03f431e.png";